<!-- Application Layout -->
<p-toast position="top-right" [style]="{ top: '10%', right: '3rem' }" />
@if (!isExternalRoute()) {
  <div class="flex h-screen bg-canvas">
    <nbx-sidebar #sidebar
      [config]="sidebarConfig()"
    />
    <div class="flex flex-col grow min-w-0">
      <!-- Header - Navbar -->
      <nbx-navbar
        [styleClass]="navbarStyleClass()"
        [config]="navbarConfig()"
        (menuClick)="toggleSidebar()"
      />
      <main
        #mainContent
        class="flex flex-col grow overflow-hidden min-w-0"
        [class.overlay-scroll]="mainScrollEnabled()"
        (scroll)="onMainScroll($event)"
      >
        <!-- Main Content -->
        <router-outlet />
      </main>
    </div>
  </div>
} @else {
  <router-outlet />
}

<nbx-dialog-outlet />
